import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import Analytics from "js/analytics";
import { Button } from "js/Components/Button";
import { getStaticUrl } from "js/config";
import { BeautifulDialog, ShowDialog } from "js/react/components/Dialogs/BaseDialog";
import { Gap10 } from "js/react/components/Gap";
import { FlexBox } from "js/react/components/LayoutGrid";
import { themeColors } from "js/react/sharedStyles";

import { DialogActions, DialogBody, DialogContent, DialogTitle, NeedHelp, UpgradeToRestoreSection } from "./components/DialogComponents";

const StyledDialogContent = styled(DialogContent)`
    &&& {
        gap: 5px;
    }
`;

const StyledDialogActions = styled(DialogActions)`
    &&& {
        justify-content: space-between;
    }
`;

function TrialFailedDialog(props: { onClose: () => void }) {
    const { onClose } = props;
    const { t } = useTranslation();

    useEffect(() => {
        Analytics.Dunning.TrialFailedDialogOpened();
    }, []);

    const handleUpgrade = async () => {
        Analytics.Dunning.TrialFailedDialogUpgradeClicked();

        // @ts-ignore
        const { default: ChangePlanDialog } = await import("js/react/components/Dialogs/ChangePlanDialog");
        ShowDialog(ChangePlanDialog, {
            analytics: { cta: "trial_failed_dialog_upgrade" }
        });

        onClose();
    };

    const handleContinueOnBasic = async () => {
        Analytics.Dunning.TrialFailedDialogDismissed();
        onClose();
    };

    return (
        <BeautifulDialog preventClose>
            <DialogBody>
                <DialogTitle>
                    <img src={getStaticUrl("/images/beautifulai-logos/beautifulai-logo-round.svg")} />
                    <Gap10 />
                    <div>{t("We couldn't process your payment")}</div>
                    <p>{t("Your trial has ended, but your presentations and content are right where you left them. Upgrade anytime to restore premium features.")}</p>
                </DialogTitle>
                <StyledDialogContent>
                    <UpgradeToRestoreSection />
                </StyledDialogContent>
                <StyledDialogActions>
                    <NeedHelp />
                    <FlexBox gap={20} wrap>
                        <Button onClick={handleContinueOnBasic} large color={themeColors.lightGray} style={{ color: "#666" }}>
                            {t("Continue on Basic")}
                        </Button>
                        <Button upgrade large onClick={handleUpgrade}>
                            {t("Upgrade")}
                        </Button>
                    </FlexBox>
                </StyledDialogActions>
            </DialogBody>
        </BeautifulDialog>
    );
}

export default TrialFailedDialog;
